module.exports = __webpack_public_path__ + "img/01-2.c8a97bf8.png";